<ul class="flex flex-column list-none p-0 m-0 gap-2">
  <app-assistant-profile (click)="selectAssistant(assistant)" *ngFor="let assistant of assistants"
                         [assistant]="assistant"></app-assistant-profile>
</ul>
